import { Component, OnInit, OnDestroy, Input, Output, EventEmitter } from '@angular/core';
import * as _ from 'lodash';

import { TrackerService } from '../../services/tracker.service';
import { TrackeritemService } from '../../services/trackeritem.service';
import { GfTranslateService } from '../../../../core/services/core.translate.service';
import { UiService } from '../../../../core/services/core.ui.service';
import { UtilsService } from '../../../../core/services/core.utils.service';
import { TagsModel } from '../../../../core/services/core.models.tags.component';
import { ProjectModel } from '../../../../core/services/project.model.service';
import { UserService } from '../../../../core/services/core.user.service';
import { UserRest } from '../../../../core/services/core.user.rest.service';
import { StateService } from '@uirouter/angular';
import { ModalComponent } from '../../../../core/config/core.modal-helpers';
import { MentionsService, MentionUser, MentionConfig } from '../../../../core/services/core.mentio.service';
import { trackerMentionUsers } from '../../services/trackeritem.mentions';


@Component({
    selector: 'trackeritem-edit-modal',
    template: require('./trackeritem.edit.modal.component.html'),
})
export class TrackeritemEditModalComponent extends ModalComponent  implements OnInit, OnDestroy {
    @Input() trackeritem: any;
    @Input() tracker: any;
    @Input() allowUpdate: any;
    @Input() allowAssignments: any;
    
    @Output() onUpdate: EventEmitter<any> = new EventEmitter<any>();
    @Output() onDelete: EventEmitter<any> = new EventEmitter<any>();
    @Output() onCancel: EventEmitter<any> = new EventEmitter<any>();
    
    params: any;
    tiDeleteModalOptions: any;
    acls: any;
    assignees: any[] = [];
    tags: any[] = [];
    errors: any = {};
    isLoaded = false;
    mode = 'edit';
    title = '';
    subtitle = '';
    footerMessage = '';
    activeTab = 'details';
    tagsOriginal: any[];
    trackerItemOriginal: any;
    overwriteMessage: string;
    workflow: any;

    // The @-mention source for the details editor.
    mentions: MentionConfig | null = null;

    constructor(
        private trackerService: TrackerService,
        private trackeritemService: TrackeritemService,
        private translateService: GfTranslateService,
        private uiService: UiService,
        private tagsModel: TagsModel,
        private utilsService: UtilsService,
        private userService: UserService,
        private userRest: UserRest,
        private projectModel: ProjectModel,
        private stateService: StateService,
        private mentioService: MentionsService
    ) {
        super();
    }

    ngOnInit(): void {
        this.trackeritemService.setTrackeritem(this.trackeritem);

        this.params = {
            id: 'ti-edit',
            title: '[#' + this.trackeritem.id + '] - ' + this.trackeritem.summary,
            subtitle: '',
            footerMessage: ''
        };
        
        this.tiDeleteModalOptions = {
            styling: {
                deleteButton: 'btn-danger'
            }
        };
        
        this.acls = {
            canUpdate: this.allowUpdate && !(this.trackeritem.lockStatus > 0),
            canAssign: this.allowAssignments,
            isAdmin: this.trackerService.acl.isAdmin(this.tracker) || this.userService.isSiteAdmin()
        };
  
        this.setPermissionOverrides();
        
        this.assignees = [];
        this.tags = [];
        this.errors = {};
        this.isLoaded = false;
        this.mode = 'edit';
        this.title = (!_.isEmpty(this.params.title)) ? this.params.title : '';
        this.subtitle = (!_.isEmpty(this.params.subtitle)) ? this.params.subtitle : '';
        this.footerMessage = (!_.isEmpty(this.params.footerMessage)) ? this.params.footerMessage : '';

        this.activeTab = 'details';
        
        if (_.isEmpty(this.allowUpdate) || _.isEmpty(this.allowAssignments)) {
            let permissions: any;
            this.projectModel.getProjectPermissions(_.get(this.tracker, 'project.unixName', ''))
            .then((ret: any) => {
                permissions = ret;
                
                if (!_.isEmpty(permissions)) {
                    this.trackerService.acl.set(permissions.rel.permissions.trackers);
                    this.acls.canUpdate = this.trackerService.acl.canUpdate(this.tracker);
                    this.acls.canAssign = this.trackerService.acl.canAssign(this.tracker);
                    this.setPermissionOverrides();
                } else {
                    this.acls.canUpdate = false;
                    this.acls.canAssign = false;
                }
            }, () => {
                this.acls.canUpdate = false;
                this.acls.canAssign = false;
            })
        }
        
        const promises = {
            t: _.has(this.tracker, 'id') && this.tracker.fields.length === 0 ? this.trackerService.load(this.tracker.id) : Promise.resolve(),
            m: this.trackerService.loadAssignees(this.tracker.id),
            g: this.tagsModel.load('trackeritem', this.trackeritem.id)
        };
        
        this.isLoaded = false;
        
        Promise.all([promises.t, promises.m, promises.g])
        .then((results) => {
            const [trackerLoadResult, assigneesLoadResult] = results;
            
            if (trackerLoadResult) {
                this.tracker = trackerLoadResult;
                
                if (_.has(this.tracker.fields, 'sprint')) {
                    this.tracker.fields.sprint.fieldElements = this.trackerService.fields.getSprintsGroupedByStatus(this.tracker.fields.sprint);
                }
                
                for (const i in this.tracker.fields) {
                    if (this.tracker.fields[i].fieldType === 8) {
                        this.tracker.fields[i].fieldElements = this.trackerService.fields.getReleasesGroupedByStatus(this.tracker.fields[i]);
                    }
                }
            }
            
            this.assignees = _.get(assigneesLoadResult, 'items', []);
            this.workflow = _.get(trackerLoadResult, 'rel.workflow.fields', {});
            this.tags = this.tagsModel.format(_.uniq(this.tagsModel.tags));
            this.tagsOriginal = this.tags.slice();

            if (!_.isEmpty(this.tracker) && _.has(this.tracker, 'id')) {
                if (_.has(this.tracker.fields, 'sprint')) {
                    this.tracker.fields.sprint.fieldElements = this.trackerService.fields.getSprintsGroupedByStatus(this.tracker.fields.sprint);
                }
            }
        },(error) => {
            console.error('Error occurred while initializing component:', error);
        })
        .then(() => {
            // Initialize mention configuration
            this.initializeMentionConfigs();
            this.isLoaded = true;
        });
    }

    ngOnDestroy(): void {
        this.mentions?.destroy();
    }


    saveLockStatus(lockStatus: any): void {
        this.trackeritem.lockStatus = lockStatus;
    }
    
    cancel(): void {
        this.onCancel.emit();
        this.closeModal();
    }
    
    goToFullEditScreen(): void {
        const trackerItemId = this.trackeritem?.id;
        const trackerId = this.trackeritem?.tracker?.id || this.tracker?.id;
        const unixName = this.trackeritem?.tracker?.project?.unixName || this.tracker?.project?.unixName;

        if (!trackerItemId || !trackerId) {
            const warningMsg = this.translateService.translate('Unable to open full tracker item editor.');
            this.uiService.message.showWarning(warningMsg, 'Tracker Item');
            return;
        }

        const params: any = {
            id: trackerItemId,
            tracker: trackerId
        };

        if (unixName) {
            params.unixName = unixName;
        }

        this.cancel();
        this.stateService.go('home.project.summary.tracker.item.edit', params, { inherit: false });
    }
    
    saveAssignees(assignees: any): void {
        this.assignees = assignees;
        $('#assign-to-menu').trigger('click');
    }
    
    isTrackerItemUpdated(): boolean {
        return !this.utilsService.compareObjects(this.trackeritem, this.trackerItemOriginal);
    }
    
    isTagsUpdated(): boolean {
        const tags = this.tags.map((item) => item.text);
        const tagsOriginal = _.map(this.tagsOriginal, 'text');
        return (tags.filter((item) => !tagsOriginal.includes(item)).length > 0 || tagsOriginal.filter((item) => !tags.includes(item)).length > 0);
    }
    
    deleteCallback(): void {
        this.onDelete.emit(this.trackeritem);
        this.closeModal();
    }
    
    submitTrackerItem(setAssigneeOnly?: boolean) {
        if (!this.isTrackerItemUpdated() && !this.isTagsUpdated()) {
            this.uiService.message.showSuccess(this.translateService.translate("There are no changes to save"), "Tracker item");
            this.closeModal();
            return;
        }
        
        if (!this.trackeritem.tracker.id) {
            this.errors = {
                tracker: {
                    error: 'Required field',
                    hasError: true
                }
            };
            
            return;
        }
        
        if (setAssigneeOnly === undefined) {
            setAssigneeOnly = false;
        }
        
        let actions = [];
        let saveSuccess = false;
        
        actions.push(this.trackeritemService.save(_.cloneDeep(this.trackeritem), { stopRedirection: true, setAssigneeOnly: setAssigneeOnly })
        .then((response) => { 
            saveSuccess = true;
            this.trackeritem.lastModifiedDate = response.lastModifiedDate;
            this.trackeritem.lastModifiedBy = response.lastModifiedBy;
            this.errors = {};
        }, (response) => {
            //Check if the error is of type "overwrite" and set the proper flag
            //Overwrite errors happens when there's an attempt to save on outdated data
            if (_.has(response, 'overwrite')) {
                if (_.has(response.overwrite, 'overwrite') && (response.overwrite.overwrite !== null)) {
                    this.userRest.getBasic(response.overwrite.overwrite)
                    .then((user: any) => {
                        this.overwriteMessage = this.translateService.translate('The tracker item has already been updated by user {{unixName}}.', {'unixName': user.unixName});
                        
                        this.uiService.message.showError(
                            this.translateService.translate('Tracker item {{tid}} was previously updated by user {{unixName}}', {'tid': this.trackeritem.id, 'unixName': user.unixName}),
                            this.translateService.translate('Tracker item overwrite'),
                            {user: user}
                        );
                    })
                    .catch((user) => {
                        this.overwriteMessage = this.translateService.translate('The tracker item has already been updated by another user.');
                    });
                }
            } else {
                this.errors = response;
                let warningMsg = this.translateService.translate('Sorry, could not update this Tracker Item');
                this.uiService.message.showWarning(warningMsg, 'Tracker Item');

                this.updateTrackeritem();
            }
        }));
        
        if (this.isTagsUpdated()) {
            actions.push(this.trackeritemService.tagsSave(this.trackeritem.id, this.tags)
            .then(() => { this.tagsOriginal = _.cloneDeep(this.tags); }));
        }
        
        Promise.all(actions)
        .then(() => {
            if (saveSuccess) {
                this.onUpdate.emit(this.trackeritem);
            }
            this.closeModal();
            
        }, (error: any) => { 
            this.onCancel.emit();
            this.closeModal();
         });
    };

    saveItem(): void {
        this.submitTrackerItem(false);
    }

    updateTrackeritem() {
        return this.trackeritemService.fetch(this.trackeritem.id, { fetchFull: false })
        .then((trackeritem: any) => {
          //this.trackeritem = _.cloneDeep(trackeritem);
          this.trackeritem.lastModifiedDate = trackeritem.lastModifiedDate;
        });
    }

    setPermissionOverrides(): void {
        if (_.get(this.tracker, 'restrictBrowse', 'N') != 'N') {
            this.acls.canFollowup = _.get(this.acls, 'canFollowup', false) ||
            _.get(this.trackeritem, 'submittedBy.id', 0) == this.userService.session.getUser().id;
        };
        
        if (this.trackeritem.lockStatus > 0) {
            this.acls.canUpdate = false;
        }
    }

    tagsUpdated($event) {
        this.trackeritem.tags = $event;
    }

    /**
     * Initialize mention configuration for the details field
     */
    initializeMentionConfigs(): void {
        this.mentions = this.mentioService.createMentionConfig({
            project: () => this.tracker?.project?.unixName || '',
            seed: () => this.getTrackerUsers(),
            roles: () => this.tracker?.project?.rel?.roles || []
        });
    }

    /**
     * Get users related to the tracker for mentions.
     *
     * The assignee picker's list is this surface's contribution -- it is
     * loaded for the modal rather than carried on the tracker item.
     */
    getTrackerUsers(): MentionUser[] {
        return trackerMentionUsers(this.mentioService, this.tracker, this.trackeritem, this.assignees || []);
    }

}
